import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=08890f98&scoped=true"
import script from "./Project.vue?vue&type=script&lang=ts"
export * from "./Project.vue?vue&type=script&lang=ts"
import style0 from "./Project.vue?vue&type=style&index=0&id=08890f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08890f98",
  null
  
)

export default component.exports